import * as actionTypes from "../ActionTypes";

export const saveGroupAction = (payload) => ({
  type: actionTypes.SAVE_GROUP_REQUEST,
  payload,
});
export const saveGroupMembersAction = (payload) => ({
    type: actionTypes.SAVE_GROUP_MEMBERS_REQUEST,
    payload,
  });
  export const saveGroupBiblePlanAction = (payload) => ({
    type: actionTypes.SAVE_GROUP_BIBLEPLAN_REQUEST,
    payload,
  });

export const saveDevotionalAction = (payload) => ({
  type: actionTypes.SAVE_DEVOTIONAL_REQUEST,
  payload,
});

export const saveDevotionalVideoAction = (payload) => ({
  type: actionTypes.SAVE_DEVOTIONAL_VIDEO_REQUEST,
  payload,
});

export const saveDevotionalJournalAction = (payload) => ({
  type: actionTypes.SAVE_DEVOTIONAL_JOURNAL_REQUEST,
  payload,
});

export const saveDevotionalTestimonyAction = (payload) => ({
  type: actionTypes.SAVE_DEVOTIONAL_TESTIMONY_REQUEST,
  payload,
});

export const saveDevotionalVerseAction = (payload) => ({
  type: actionTypes.SAVE_DEVOTIONAL_VERSE_REQUEST,
  payload,
});

export const readDevotionalsAction = (payload) => ({
    type: actionTypes.READ_DEVOTIONALS_REQUEST,
    payload,
  });
  export const saveGroupDevotionalsAction = (payload) => ({
    type: actionTypes.SAVE_GROUP_DEVOTIONALS_REQUEST,
    payload,
  });

  export const saveGroupJournalsAction = (payload) => ({
    type: actionTypes.SAVE_GROUP_JOURNALS_REQUEST,
    payload,
  });

  export const saveGroupVideosAction = (payload) => ({
    type: actionTypes.SAVE_GROUP_VIDEOS_REQUEST,
    payload,
  });
  
  // NEW: Save Group Curriculums Action
  export const saveGroupCurriculumsAction = (payload) => ({
    type: actionTypes.SAVE_GROUP_CURRICULUMS_REQUEST,
    payload,
  });
  
  // NEW: Save Group Testimonies Action
  export const saveGroupTestimoniesAction = (payload) => ({
    type: actionTypes.SAVE_GROUP_TESTIMONIES_REQUEST,
    payload,
  });

  export const readMyGroupsAction = (payload) => ({
    type: actionTypes.READ_MY_GROUPS_REQUEST,
    payload,
  });
  // GroupsAction.js
export const deleteGroupAction = (payload) => ({
  type: actionTypes.DELETE_GROUP_REQUEST,
  payload, // { data: { _id }, callback }
});
export const updateGroupAction = (payload) => ({
  type: actionTypes.UPDATE_GROUP_REQUEST,
  payload, // { data, callback }
});
export const saveYoutubePlanAction = (payload) => ({
  type: actionTypes.SAVE_YOUTUBE_PLAN_REQUEST,
  payload, // { data, callback }
});
